import { liveQuery } from 'dexie';
import { create } from 'zustand';
import { db } from '../storage/db.ts';
import { normalizeFileUris, type ProjectFile } from '../storage/record.ts';

/** The project gallery, kept in sync with IndexedDB (also across tabs) via Dexie liveQuery. */
interface LibraryState {
  projects: ProjectFile[];
  ready: boolean;
}

export const useLibrary = create<LibraryState>(() => ({ projects: [], ready: false }));

let started = false;

export function startLibrary(): void {
  if (started) return;
  started = true;
  liveQuery(() => db().projects.orderBy('updatedAt').reverse().toArray()).subscribe({
    next: (all) =>
      useLibrary.setState({ projects: all.filter((p) => !p.deletedAt).map(normalizeFileUris), ready: true }),
    error: () => useLibrary.setState({ ready: true }),
  });
}
